import { VehicleModel } from './vehicle.model';
import { InstructorModel } from './instructor.model';
import { OrganizationModel } from './organization.model';
import { AvailabilityTimeCollectionModel } from './availability-time-collection.model';

export class VehicleAvailabilityModel {
  amountAvailableRoom?: number;
  availabilityTimeCollection?: AvailabilityTimeCollectionModel;
  createdByUsername?: string;
  createdDate?: any;
  enabled?: boolean;
  endDate?: any;
  id?: number;
  idAvailabilityTimeCollection?: number;
  idInstructor?: number;
  idOrganization?: number;
  idVehicle?: number;
  instructor?: InstructorModel;
  organization?: OrganizationModel;
  startDate?: any;
  time?: string;
  updatedByUsername?: string;
  updatedDate?: any;
  vehicle?: VehicleModel;
  idAvailabilityTime?: number;

  constructor(options: VehicleAvailabilityModel = {}) {
    this.amountAvailableRoom = options.amountAvailableRoom || null;
    this.availabilityTimeCollection = options.availabilityTimeCollection || null;
    this.createdByUsername = options.createdByUsername || null;
    this.createdDate = options.createdDate || null;
    this.enabled = options.enabled || null;
    this.endDate = options.endDate || null;
    this.id = options.id || null;
    this.idAvailabilityTimeCollection = options.idAvailabilityTimeCollection || null;
    this.idInstructor = options.idInstructor || null;
    this.idOrganization = options.idOrganization || null;
    this.idVehicle = options.idVehicle || null;
    this.instructor = options.instructor || null;
    this.organization = options.organization || null;
    this.startDate = options.startDate || null;
    this.time = options.time || null;
    this.updatedByUsername = options.updatedByUsername || null;
    this.updatedDate = options.updatedDate || null;
    this.vehicle = options.vehicle || null;
    this.idAvailabilityTime = options.idAvailabilityTime || null;
  }
}
